<template>
    <div>
        <el-dialog title="添加新闻"  v-model="dialogFormVisible" width="90%" top="5%">
            <el-form ref="formNews" :model="formNews" :rules="formNewsRules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="新闻名" prop="Title" :label-width="formLabelWidth">
                            <el-input v-model="formNews.Title"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="新闻版本" prop="Lang" :label-width="formLabelWidth">
                            <el-select v-model="formNews.Lang" placeholder="请选择">
                                <el-option
                                    v-for="item in Lang"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="新闻状态" prop="Status" :label-width="formLabelWidth">
                            <el-select v-model="formNews.Status" placeholder="请选择">
                                <el-option
                                    v-for="item in Status"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="新闻图片" prop="attchs" :label-width="formLabelWidth">
                            <span v-for="( item, index ) in formNews.attchs" :key="item"  class="removeImage" :style="spanleft(index)">
                                <pfDelete v-if="item" @click="handleRemoveImage(item)" style="width: 1em; height: 1em; margin-right: 8px" />
                            </span>
                            <el-upload
                                class="avatar-uploader" 
                                :show-file-list="false"
                                :on-progress="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                >
                                <span v-for="( item ) in formNews.attchs" :key="item">
                                    <el-image v-if="item" style="width: 100px; height: 100px" :src="item" class="avatar" />
                                </span>
                                <el-icon v-if="formNews.attchs.length < 3" class="avatar-uploader-icon"><pfPlus /></el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="新闻内容" prop="Content" :label-width="formLabelWidth">
                            <el-input v-model="formNews.Content"  type="textarea" :rows="2"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="closedDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api/api'
import cxf from '@/utils/GeneralFn'
import { Plus, Delete } from '@element-plus/icons-vue'
    export default {
        name: "addNewsDialog",
        components: { 
            "pfPlus": Plus,
            "pfDelete": Delete
         },
        data() {
            return {
                formNews:{
                    attchs:[]
                },
                formNewsRules:{
                    Title: [
                        { required: true, message: 'Please input Title', trigger: 'blur' },
                    ],
                    Lang: [
                        { required: true, message: 'Please input Lang', trigger: 'blur' },
                    ],
                    Content: [
                        { required: true, message: 'Please input Content', trigger: 'blur' },
                    ]
                },
                iconArr:{
                    "pfPlus":Plus
                },
                Lang:cxf.getProductLang(),
                Status:cxf.getNewStatus(),
                mType:cxf.getMainType(),
                sType:[],
                newsFile:[],
                dialogFormVisible:false,
                formLabelWidth:100,
                formTypeNumberLabelTypeWidth:200,
                formProduct: {
                    attchs: [],
                    typeNumberName:1,
                }
            }
        },
        props:{
            isAddNewsShow:Boolean,
            timekey:Number
        },
        created(){
        },
        methods:{
            closedDialog(){
                this.dialogFormVisible = false;
                this.$refs['formNews'].resetFields();
                this.$emit('isAddNewsShow', false);
            },
            submitForm(){
                this.$refs['formNews'].validate(( valid ) => {
                    if (valid) {
                        let _addFromData = new FormData();
                        const data = this.formNews;
                        _addFromData.append("apiType", "fromData");
                        for (let item in data) {
                            if ( item === 'attchs') {
                                for (let d in this.newsFile) {
                                    if (this.newsFile.length !== 0 ) {
                                        _addFromData.append('file', this.newsFile[d]);
                                    }
                                }
                            } else {
                                _addFromData.append(item, data[item]);
                            }
                            
                        }

                        api.postAddNews( _addFromData ).then( res => {
                            if ( res.data.success) {
                                this.$message({
                                    message: '产品录入成功！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.dialogFormVisible = false;
                            this.$refs['formNews'].resetFields();
                            this.$emit('hanldeCurrentPage');
                        }).catch( () => {
                            this.$message({
                                message: '产品录入出错，请联系相关员！',
                                type: 'errow'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            async handleAvatarSuccess( n ,file) {
                const _addFromData = new FormData();
                _addFromData.append("apiType", "fromData");
                _addFromData.append("file", file.raw)

                let _resImage = await api.postUploadImage( _addFromData );
                
                if ( _resImage.data.success ) {
                    let imageId = _resImage.data.data;
                    this.newsFile.push(file.raw)
                    let _resimageUrl = await api.getSysFileInfoPreview( { id:imageId } );
                    if ( _resimageUrl.status ) {
                        this.formNews.attchs.push(window.URL.createObjectURL(new Blob([_resimageUrl.data])));
                    }
                } else {
                    this.$message({
                        message: '图片录入出错，请联系相关员！',
                        type: 'errow'
                    })
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            handleRemoveImage ( n ) {
                this.formNews.attchs = this.formNews.attchs.filter( ( item, index ) => {
                    if (  item == n) {
                        this.newsFile.splice(index, 1);
                    }
                    if ( item != n ) {
                        return item;
                    }
                });
            },
            handleSubType( mid ) {
                this.sType = cxf.getSubType( mid );
            },
            spanleft( index ) {
                if ( index === 0 ) {
                    return "left:0px;"
                } else {
                    let _wt = index * 100 + index * 20;
                    return "left:" + _wt + "px;"
                }
            }
        },
        watch:{
            isAddNewsShow( newv ){
                this.dialogFormVisible = newv;
            },
            timekey( newv, oldv ){
                if (newv !== oldv && oldv !== "")
                this.dialogFormVisible = this.$props.isAddNewsShow;
            }
        }
    }
</script>


<style scoped>
.avatar-uploader span,i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 15px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
.dialog-footer {
    padding-top:20px;
}

.removeImage{
    width: 100px;
    height: 30px;
    z-index: 2000 !important;
    position: absolute;
    top:0px;
    background: black;
    opacity: 0.5;
}
</style>